module.exports = __webpack_public_path__ + "media/fr_Beta Digitis - Gif.gif.de351d43.mp4";